import React, { memo, useContext } from 'react';

import { BrandCategoryCard } from '../brand-category-card';
import { AppContext } from 'src/components/app-context';
import { Panel, PanelTitle } from '@prisjakt/ui/panel';
import CategoryTreeListing from '../category-tree-listing';

import type {
  BrandPageFragment,
  CategoryListingFragment,
  CategoryTreeListingFragment,
} from 'src/types';
import * as S from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

const CategoryListing = (
  props: Pick<CategoryListingFragment, 'categories'> &
    Pick<CategoryTreeListingFragment, 'categoryTree'> & {
      brand: Pick<BrandPageFragment, 'id' | 'name'> &
        Partial<Pick<BrandPageFragment, 'logo'>>;
    }
) => {
  const { categories, categoryTree, brand } = props;
  const { t, linkTo } = useContext(AppContext);

  return (
    <>
      <Panel>
        <PanelTitle>
          {t('brand', 'popular-categories.title', { brand: brand.name })}
        </PanelTitle>
        <S.CategoryGrid>
          {categories &&
            categories.nodes &&
            categories.nodes.map((category, index) => {
              const to = linkTo('brandCategory', {
                ...category,
                brandId: brand.id,
              });
              return (
                category && (
                  <BrandCategoryCard
                    key={category.id}
                    categoryImage={category.logo!}
                    categoryName={category.name!}
                    brandLogo={brand.logo!}
                    brandName={brand.name}
                    to={to}
                    onClick={() =>
                      trackInternalNavigationClick({
                        scope: InternalNavigationScope.BRAND_CATEGORY_CARD,
                        nextPage: to,
                        index,
                      })
                    }
                  />
                )
              );
            })}
        </S.CategoryGrid>
      </Panel>
      <S.CategoryTree>
        <CategoryTreeListing categoryTree={categoryTree} brand={brand} />
      </S.CategoryTree>
    </>
  );
};

export default memo(CategoryListing);
